export const PAGE_FIX_FIXABLE_TYPES = {
    accessibility_source_code: 'accessibility_source_code',
    accessibility_check: 'accessibility_check',
    misspelling: 'spelling_error',
    link: 'link',
    custom: 'custom',
} as const;
